import { render, staticRenderFns } from "./DisagreePropertyDivision.vue?vue&type=template&id=3660fff6"
import script from "./DisagreePropertyDivision.vue?vue&type=script&lang=ts"
export * from "./DisagreePropertyDivision.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports